import { AdminSidebar } from "./AdminSidebar";
import AdminAIAssistant from "./AdminAIAssistant";

export const AdminLayout = ({ children, title, subtitle, actions }) => {
  return (
    <div className="min-h-screen bg-black text-white">
      <AdminSidebar />
      
      <main className="md:ml-64 min-h-screen">
        {/* Header */}
        <header className="bg-[#0a0a0a] border-b border-white/10 px-4 md:px-8 py-4 md:py-6">
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
              <h1 className="text-lg md:text-2xl font-bold text-white truncate">{title}</h1>
              {subtitle && (
                <p className="text-xs md:text-sm text-white/50 mt-1 truncate">{subtitle}</p>
              )}
            </div>
            {actions && <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">{actions}</div>}
          </div>
        </header>

        {/* Content */}
        <div className="p-4 md:p-8">
          {children}
        </div>
      </main>

      {/* Floating AI assistant — available on every admin page */}
      <AdminAIAssistant />
    </div>
  );
};

export default AdminLayout;
